export default "__VITE_ASSET__14724f07__"